module.exports = __webpack_public_path__ + "img/bgYellowQR.5849cffb.svg";